// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-87c45072]{color:#000}a[data-v-87c45072]:hover{color:#2f4f4f!important}.footer[data-v-87c45072]{background-color:rgba(2,178,223,.9647058823529412);position:fixed;bottom:0;left:0;right:0;height:24px;text-align:center}.footer span[data-v-87c45072]{font-size:13px;margin:0 10px;color:#000}", ""]);
// Exports
module.exports = exports;
